<template>
  <v-container>
    <h1 class="pt-3 pb-5">{{activeTerminal ? `Card Reader - ${activeTerminal}`: "Please choose terminal you need in AppBar List"}}</h1>
    <v-card v-if="activeTerminal">
      <v-card-title>Сonfig</v-card-title>
      <v-card-text>
        <v-form ref="form" @submit.prevent="submit()">
          <v-text-field 
            label="Host"
            placeholder="Host"
            outlined
            dense
            v-model="config.host"
          ></v-text-field>
          <v-text-field 
            label="Merchant id"
            placeholder="Merchant id"
            outlined
            dense
            v-model="config.merchant_id"
          ></v-text-field>
          <v-text-field 
            label="Terminal id"
            placeholder="Terminal id"
            outlined
            dense
            v-model="config.terminal_id"
          ></v-text-field>
          <v-text-field 
            label="Operator id"
            placeholder="Operator id"
            outlined
            dense
            v-model="config.operator_id"
          ></v-text-field>
          <v-text-field 
            label="Secure device"
            placeholder="Secure device"
            outlined
            dense
            v-model="config.secure_device"
          ></v-text-field>
          <v-btn type="submit" style="width: 100%;" color="primary" :disabled="btn_disabled">Save</v-btn>
        </v-form>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "CardReader",
  data: () => ({
    config: {
      host: "127.0.0.1",
      secure_device: "EMV_IUC285_RAPIDCONNECT",
      terminal_id: "",
      merchant_id: "",
      operator_id: "8901",
    },
    btn_disabled: false
  }),
  computed: {
    ...mapState('terminals', ["activeTerminal", "terminals"]),
    activeId() {
      const elem = this.terminals.find(n => n.name == this.activeTerminal);
      return elem ? elem.id : null;
    }
  },
  watch: {
    activeId() {
      if (this.activeTerminal !== null) {
        this.getConfig();
      }
    },
  },
  methods: {
    getConfig() {
      this.$http.get("/rest/card/" + this.activeId)
        .then((res) => {
          Object.keys(this.config).forEach(key => {
            this.config[key] = res.data[key];
          })
        })
        .catch(() => {
          this.config = {
            host: "127.0.0.1",
            secure_device: "EMV_IUC285_RAPIDCONNECT",
            terminal_id: "",
            merchant_id: "",
            operator_id: "8901",
          }
        })
    },
    submit() {
      const config = this.config;
      config["kiosk"] = this.activeId;
      this.btn_disabled = true;
      this.$http.post("/rest/card", config)
        .then((res) => {
          this.btn_disabled = false;
          return res;
        })
        .catch((err) => {
          this.btn_disabled = false;
          return err
        })
    }
  }
}
</script>
